import { BatchAnalysis } from '@/components/BatchAnalysis';

export function BatchAnalysisPage() {
  return (
    <div className="max-w-5xl mx-auto px-4 py-10">
      <div className="mb-6">
        <h1 className="text-2xl font-semibold text-gray-900">Batch Analysis</h1>
        <p className="text-sm text-gray-600">Upload a folder of images to run quick, parallel analyses with progress tracking.</p>
      </div>
      <BatchAnalysis />
    </div>
  );
}
